import styled from 'styled-components';
import { COLORS } from '../../../styles/variables';
import { AlphaTheme } from '../../../../design-system/ThemeProvider/alphaTheme';

export const OfferTypeListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: Audi Type;
`;

export const CheckBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Description = styled.div<{ disabled?: boolean }>`
  padding-top: 12px;
  letter-spacing: 0.002px;
  line-height: 20px;
  font-size: 12px;
  color: ${({ disabled, theme }: { disabled?: boolean; theme: Partial<AlphaTheme> }) =>
    disabled
      ? (theme.foregroundDisabled100 ?? COLORS.grey30)
      : (theme.foregroundNeutral200 ?? COLORS.grey60)};
  padding-left: 32px;
`;
